import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/sobre",
      name: "About",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/About.vue")
    },
    {
      path: "/imoveis/:id/:slug",
      name: "Properties",
      component: () =>
        import(/* webpackChunkName: "properties" */ "../views/Properties.vue")
    },
    {
      path: "/imoveis",
      name: "PropertiesList",
      component: () =>
        import(
          /* webpackChunkName: "propertiesList" */ "../views/PropertiesList.vue"
        )
    },
    {
      path: "/termos",
      name: "TermsOfUse",
      component: () =>
        import(/* webpackChunkName: "terms" */ "../views/terms.vue")
    },
    {
      path: "/blog",
      name: "Blog",
      component: () =>
        import(/* webpackChunkName: "blog" */ "../views/Blog.vue")
    },
    {
      path: "/blog/:slug",
      name: "BlogPost",
      component: () =>
        import(/* webpackChunkName: "blogPost" */ "../views/BlogPost.vue")
    }
  ],

  scrollBehavior() {
    document.getElementById("app").scrollIntoView();
  },

  linkExactActiveClass: "active"
});

export default router;
